import { render, staticRenderFns } from "./InteractiveLegend.vue?vue&type=template&id=3e5f870a&scoped=true"
import script from "./InteractiveLegend.vue?vue&type=script&lang=ts"
export * from "./InteractiveLegend.vue?vue&type=script&lang=ts"
import style1 from "./InteractiveLegend.vue?vue&type=style&index=1&id=3e5f870a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f870a",
  null
  
)

export default component.exports